import api from "./client";

export async function getUsers() {
  const { data } = await api.get("/api/users");
  return data.data ?? data;
}

export async function createUser(payload) {
  const { data } = await api.post("/api/users", payload);
  return data;
}

export async function updateUser(id, payload) {
  const { data } = await api.put(`/api/users/${id}`, payload);
  return data;
}

export async function deleteUser(id) {
  await api.delete(`/api/users/${id}`);
}

export async function toggleActive(id, is_active) {
  const { data } = await api.patch(`/api/users/${id}/active`, { is_active });
  return data;
}
